/**
 * Check if the given parameter has a truthy value
 * @param {*} value
 * @return {Boolean}
 */
var TRUTHY_VALUES = [ true, 1, 'true', '1', 'enabled', 'yes', 'active' ];
export default function ( value ) {
  return TRUTHY_VALUES.indexOf( value.toLowerCase().trim() ) >= 0;
}